export default __webpack_public_path__ + "static/media/04_reeach-maker_tour_uneditable-areas_v2.980e4df5.mp4";